__turbopack_context__.v({
  "bentoDesktop": "index-module__cT24Aq__bentoDesktop",
  "bentoMobile": "index-module__cT24Aq__bentoMobile",
  "root": "index-module__cT24Aq__root",
});
